import { Field } from '#models/questionnaire';
import { useFieldStyles, useLeadField } from '#modules/LeadGeneration/hooks/field';
import DateFnsUtils from '@date-io/date-fns';
import { Box, TextField as MatTextField, Typography } from '@material-ui/core';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { format, isValid } from 'date-fns';
import * as React from 'react';

interface DatePickerFieldProps {
  field: Field;
  handleChangeFields: (type: string, value: any) => void;
}

export const DatePickerField = ({ field, handleChangeFields }: DatePickerFieldProps) => {
  const pickerRef = React.useRef(null);
  const { textField, stylesLabel, datePickerCustom } = useFieldStyles();
  const [{ value }, { error, touched }, { setValue }] = useLeadField(field);

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div ref={pickerRef}>
        <Box display='flex' alignItems='center' justifyContent='space-between'>
          <Typography variant='subtitle2' className={stylesLabel}>
            {field.title}
          </Typography>
        </Box>
        <DatePicker
          disableToolbar
          variant='inline'
          helperText=''
          minDate={new Date()}
          labelFunc={() => {
            if (isValid(value)) {
              return format(value as Date, 'dd/MM/yyyy');
            }
            return '';
          }}
          PopoverProps={{
            anchorEl: pickerRef.current,
            className: datePickerCustom
          }}
          value={value}
          onChange={(value) => {
            setValue(value);
            handleChangeFields(field.type, value);
          }}
          TextFieldComponent={(props) => (
            <MatTextField
              {...props}
              className={textField}
              error={Boolean(error && touched)}
              placeholder={field.placeholderText}
              fullWidth
              variant='outlined'
              InputLabelProps={{
                shrink: true
              }}
              InputProps={{ className: 'lead-input swyft-input' }}
              size='small'
            />
          )}
        />
        {error && touched && (
          <Typography variant='subtitle2' color='error'>
            {error}
          </Typography>
        )}
      </div>
    </MuiPickersUtilsProvider>
  );
};
